import { Loop } from "@mui/icons-material";
import { styled } from "@mui/material";

const Title = styled('div')(({ theme }) => ({
  fontSize: 'large',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 500,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  marginRight: '7px',
  color: '#484848',
  marginBottom: '8px',
}));

const Subtitle = styled('div')(({ theme }) => ({
  fontSize: '17px',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  color: 'grey',
  marginBottom: '8px',
  marginLeft: '15px',
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  width: '550px',
  marginTop: '20px',
}));

const LoopStyled = styled(Loop)(({ theme }) => ({
  cursor: 'pointer',
  color: '#4a148c',
  '&:hover': {
    color: '#4a148c',
    cursor: 'pointer',
  }
}));

const TitleWithFetchData = ({
  title,
  noRefresh,
  fetchData,
  subTitle,
  saldoALaFecha,
}) => {
  return (
    <Container>
      <Title sx={{ marginLeft: '15px' }}>{title}</Title>
      {!noRefresh && fetchData && <LoopStyled onClick={fetchData} />}
      {subTitle && <Subtitle>Saldo a la fecha: {saldoALaFecha}</Subtitle>}
    </Container>
  );
};

export default TitleWithFetchData;